import {
  forwardRef,
  useState,
  type ImgHTMLAttributes,
  type ReactNode,
} from "react";

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallback?: ReactNode;
}

export const Image = forwardRef<HTMLImageElement, ImageProps>(function Image(
  { fallback, src, className, onError, ...props },
  ref,
) {
  const [failedSource, setFailedSource] = useState<string>();
  const showFallback =
    fallback !== undefined && (!src || failedSource === src);

  if (showFallback) return fallback;

  return (
    <img
      {...props}
      ref={ref}
      className={["ark-image", className].filter(Boolean).join(" ")}
      src={src}
      onError={(event) => {
        setFailedSource(src);
        onError?.(event);
      }}
    />
  );
});
